/* format money function */

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || "{{amount}}";

  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split(".");
    let dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    let centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  let value = "";
  const matchResult = formatString.match(placeholderRegex);
  const placeholder = matchResult ? matchResult[1] : "amount";

  switch (placeholder) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

window.formatMoney = formatMoney;
window.themeVariables = window.themeVariables || {};
window.themeVariables.settings = window.themeVariables.settings || {};

/* format money function */

/* back to top button js start */

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.back-to-top');
  if (btn) {
    btn.classList.add('hidden');
    window.addEventListener('scroll', function () {
      if (window.scrollY > 300) {
        btn.classList.remove('hidden');
      } else {
        btn.classList.add('hidden');
      }
    }, { passive: true });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});

/* back to top button js end */

/* FAQ js start */

document.addEventListener('DOMContentLoaded', function () {
  initFAQSections();
});

const faqInstances = new Map();

function initFAQSections(container = document) {
  const FAQSections = container.querySelectorAll('.faq-section[data-section-id]');

  FAQSections.forEach(FAQSection => {
    const sectionId = FAQSection.getAttribute('data-section-id');
    const FAQItems = FAQSection.querySelectorAll('.faq-item');
    const allowMultiple = FAQSection.getAttribute('data-allow-multiple') === 'true';

    FAQItems.forEach(item => {
      const toggle = item.querySelector('[data-FAQ-toggle]');
      if (!toggle) return;

      const clickHandler = () => toggleFAQ(item, FAQItems, allowMultiple);
      const keydownHandler = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleFAQ(item, FAQItems, allowMultiple);
        }
      };

      toggle.addEventListener('click', clickHandler);
      toggle.addEventListener('keydown', keydownHandler);

    });
  });
}

function toggleFAQ(item, allItems, allowMultiple) {
  const isActive = item.classList.contains('active');
  const toggle = item.querySelector('[data-FAQ-toggle]');

  if (!allowMultiple) {
    allItems.forEach(otherItem => {
      if (otherItem !== item && otherItem.classList.contains('active')) {
        otherItem.classList.remove('active');
        const otherToggle = otherItem.querySelector('[data-FAQ-toggle]');
        if (otherToggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  if (isActive) {
    item.classList.remove('active');
    toggle.setAttribute('aria-expanded', 'false');
  } else {
    item.classList.add('active');
    toggle.setAttribute('aria-expanded', 'true');
  }
}

/* FAQ js end */

/* Logo List js start */

class LogoListSection {
  constructor(container) {
    this.container = container;
    this.slideshows = container.querySelectorAll('.logo-list-slideshow');
    this.isDesktop = window.innerWidth >= 990;
    this.isMobile = window.innerWidth < 750;

    if (this.slideshows.length && typeof Swiper !== 'undefined') {
      this.init();
      this.bindEvents();
    }
  }

  init() {
    const shouldInit = this.shouldInitializeSlideshow();

    this.slideshows.forEach(slideshow => {
      if (shouldInit && !slideshow.swiper) {
        this.createSwiper(slideshow);
      }
      else if (!shouldInit && slideshow.swiper) {
        this.destroySwiper(slideshow);
      }
    });
  }

  shouldInitializeSlideshow() {
    const desktopView = this.container.dataset.desktopView;
    const mobileView = this.container.dataset.mobileView;

    if (this.isDesktop) return desktopView === 'slideshow';
    if (this.isMobile) return mobileView === 'slideshow';
    return desktopView === 'slideshow';
  }

  createSwiper(slideshow) {
    const desktopItems = parseInt(this.container.dataset.desktopItems) || 6;
    const mobileItems = parseInt(this.container.dataset.mobileItems) || 2;
    const autoplay = slideshow.dataset.autoplay === 'true';
    const speed = (parseInt(slideshow.dataset.speed) || 5) * 1000;

    slideshow.swiper = new Swiper(slideshow, {
      slidesPerView: mobileItems,
      spaceBetween: 16,
      loop: true,
      watchSlidesProgress: true,
      a11y: {
        enabled: true,
      },

      navigation: {
        nextEl: slideshow.querySelector('.logo-item-slideshow-next'),
        prevEl: slideshow.querySelector('.logo-item-slideshow-prev'),
      },

      pagination: {
        el: slideshow.querySelector('.logo-item-slideshow-pagination-progressbar'),
        type: "progressbar",
      },

      autoplay: autoplay ? {
        delay: speed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,

      breakpoints: {
        750: {
          slidesPerView: Math.min(desktopItems - 2, 4),
          spaceBetween: 24
        },
        990: {
          slidesPerView: desktopItems,
          spaceBetween: 24
        }
      }
    });

    slideshow.classList.add('swiper-initialized');
  }

  destroySwiper(slideshow) {
    if (slideshow.swiper) {
      slideshow.swiper.destroy(true, true);
      slideshow.swiper = null;
      slideshow.classList.remove('swiper-initialized');
    }
  }

  bindEvents() {
    let resizeTimer;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const wasDesktop = this.isDesktop;
        const wasMobile = this.isMobile;

        this.isDesktop = window.innerWidth >= 990;
        this.isMobile = window.innerWidth < 750;

        if (wasDesktop !== this.isDesktop || wasMobile !== this.isMobile) {
          this.init();
        } else {
          this.slideshows.forEach(s => {
            if (s.swiper) {
              requestAnimationFrame(() => s.swiper.update());
            }
          });
        }
      }, 200);
    });
  }

  slideToBlock(blockId) {
    const block = this.container.querySelector(`[data-block-id="${blockId}"]`);
    if (!block) return;

    const slide = block.closest('.swiper-slide');
    if (!slide) return;

    const slideIndex = slide.dataset.swiperSlideIndex;
    this.slideshows.forEach(slideshow => {
      if (slideshow.swiper && slideIndex !== undefined) {
        slideshow.swiper.slideToLoop(parseInt(slideIndex));
      }
    });
  }
}

function initLogoList() {
  document.querySelectorAll('.logo-list').forEach(section => {
    if (!section.logoListInstance) {
      section.logoListInstance = new LogoListSection(section);
    }
  });
}

document.addEventListener('DOMContentLoaded', initLogoList);

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initLogoList);

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.logo-list').forEach(section => {
      if (section.logoListInstance) {
        section.logoListInstance.slideshows.forEach(s => section.logoListInstance.destroySwiper(s));
      }
    });
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('.logo-list');
    if (section && section.logoListInstance) {
      const blockId = event.detail.blockId;
      if (blockId) {
        section.logoListInstance.slideToBlock(blockId);
      }
    }
  });
}

/* Logo List js end */

/* main address js start */

function toggleAddressForm() {
  const overlay = document.getElementById('add-address-overlay');
  if (!overlay) {
    return;
  }

  const isActive = overlay.classList.contains('active');

  if (isActive) {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  } else {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      initCountryProvinceSelector('new');
    }, 50);
  }
}

function toggleEditForm(addressId) {
  const overlay = document.getElementById('edit-overlay-' + addressId);
  if (!overlay) {
    return;
  }

  const isActive = overlay.classList.contains('active');

  if (isActive) {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  } else {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      initCountryProvinceSelector(addressId);
    }, 50);
  }
}

function editAddress(addressId) {
  toggleEditForm(addressId);
}

function deleteAddress(addressId) {
  if (confirm('Are you sure you want to delete this address?')) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/account/addresses/' + addressId;

    const methodInput = document.createElement('input');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'delete';

    const csrfToken = document.querySelector('meta[name="csrf-token"]');
    if (csrfToken) {
      const tokenInput = document.createElement('input');
      tokenInput.type = 'hidden';
      tokenInput.name = 'authenticity_token';
      tokenInput.value = csrfToken.getAttribute('content');
      form.appendChild(tokenInput);
    }

    form.appendChild(methodInput);
    document.body.appendChild(form);
    form.submit();
  }
}

function initCountryProvinceSelector(addressId) {
  const isNew = addressId === 'new';
  const countryId = isNew ? 'AddressCountryNew' : 'AddressCountry_' + addressId;
  const provinceId = isNew ? 'AddressProvinceNew' : 'AddressProvince_' + addressId;
  const containerId = 'AddressProvinceContainer_' + addressId;

  const countrySelect = document.getElementById(countryId);
  const provinceSelect = document.getElementById(provinceId);
  const provinceContainer = document.getElementById(containerId);

  if (!countrySelect || !provinceSelect || !provinceContainer) {
    return;
  }

  if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
    new Shopify.CountryProvinceSelector(
      countryId,
      provinceId,
      {
        hideElement: containerId
      }
    );
  }
}

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    const activeOverlays = document.querySelectorAll('.address-popup-overlay.active');
    activeOverlays.forEach(overlay => {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const hasAddressOverlays =
    document.getElementById('add-address-overlay') ||
    document.querySelector('.address-popup-overlay');

  if (!hasAddressOverlays) return;

  const start = Date.now();
  const timeoutMs = 2000;

  (function waitForShopifyCommon() {
    if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
      const addOverlay = document.getElementById('add-address-overlay');
      if (addOverlay && addOverlay.classList.contains('active')) {
        initCountryProvinceSelector('new');
      }

      const editOverlays = document.querySelectorAll('.address-popup-overlay[id^="edit-overlay-"]');
      editOverlays.forEach(overlay => {
        if (overlay.classList.contains('active')) {
          const addressId = overlay.id.replace('edit-overlay-', '');
          initCountryProvinceSelector(addressId);
        }
      });
      return;
    }

    if (Date.now() - start > timeoutMs) return;
    setTimeout(waitForShopifyCommon, 50);
  })();
});

/* main address js end */

/* login page css start */

class LoginPage {
  constructor() {
    this.recoveryButton = document.querySelector('.login-page-form-action-row-item');
    this.recoveryDiv = document.querySelector('.login-page-recovery');
    this.loginDiv = document.querySelector('.login-page-login');
    this.cancelButton = document.querySelector('.login-page-button-secondary');
    this.init();
  }

  init() {
    if (this.recoveryButton && this.recoveryDiv && this.loginDiv) {
      this.recoveryButton.onclick = () => this.toggleRecovery();
    }

    if (this.recoveryButton && this.recoveryDiv && this.loginDiv) {
      this.cancelButton.onclick = () => this.cancelRecovery();
    }
  }

  toggleRecovery() {
    this.recoveryDiv.classList.toggle('active');
    this.loginDiv.classList.toggle('hide');
  }

  cancelRecovery() {
    this.recoveryDiv.classList.remove('active');
    this.loginDiv.classList.remove('hide');
  }
}
function initLoginPage(container = document) {
  if (container.querySelector('.login-page-login') || container.querySelector('.login-page-recovery')) {
    new LoginPage();
  }
}

window.addEventListener('load', () => initLoginPage());

/* login page css start */

/* password hide and show js start */

class PasswordToggle {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.passwordField = wrapper.querySelector('.password-input');
    this.toggleBtn = wrapper.querySelector('.password-toggle-btn');
    this.hideIcon = wrapper.querySelector('.password-hide');
    this.showIcon = wrapper.querySelector('.password-show');

    if (this.passwordField && this.toggleBtn) {
      this.init();
    }
  }

  init() {
    this.toggleBtn.addEventListener('click', () => this.toggle());
    this.passwordField.addEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'P') {
        e.preventDefault();
        this.toggle();
      }
    });
  }

  toggle() {
    const isPassword = this.passwordField.type === 'password';
    this.passwordField.type = isPassword ? 'text' : 'password';

    if (isPassword) {
      this.hideIcon.style.display = 'none';
      this.showIcon.style.display = 'block';
      this.toggleBtn.setAttribute('aria-label', 'Hide password');
    } else {
      this.hideIcon.style.display = 'block';
      this.showIcon.style.display = 'none';
      this.toggleBtn.setAttribute('aria-label', 'Show password');
    }
  }

  destroy() {
    if (this.toggleBtn) {
      this.toggleBtn.removeEventListener('click', this.toggle);
    }
  }
}

const passwordToggleInstances = [];

function initAllPasswordToggles() {
  const passwordWrappers = document.querySelectorAll('.password-input-wrapper');

  passwordWrappers.forEach(wrapper => {
    const instance = new PasswordToggle(wrapper);
    passwordToggleInstances.push(instance);
  });
}

document.addEventListener('DOMContentLoaded', initAllPasswordToggles);

function reinitPasswordToggles() {
  passwordToggleInstances.forEach(instance => instance.destroy());
  passwordToggleInstances.length = 0;

  initAllPasswordToggles();
}

window.reinitPasswordToggles = reinitPasswordToggles;

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { PasswordToggle, initAllPasswordToggles, reinitPasswordToggles };
}

/* password hide and show js end */

/* Password Page Popup js start */

class PasswordPopup {
  constructor() {
    this.popup = document.querySelector('.password-popup-content');
    this.init();
  }

  init() {
    if (this.popup) {
      document.querySelectorAll('.password-link-content').forEach(element => {
        element.addEventListener('click', () => this.openPopup());
      });

      document.querySelectorAll('.password-popup-close').forEach(element => {
        element.addEventListener('click', () => this.closePopup());
      });

      window.addEventListener('click', (event) => this.handleOutsideClick(event));
      this.handleKeyboardEvents();
    }
  }

  openPopup() {
    this.popup.style.display = 'flex';
  }

  closePopup() {
    this.popup.style.display = 'none';
  }

  handleOutsideClick(event) {
    if (event.target === this.popup) {
      this.closePopup();
    }
  }

  handleKeyboardEvents() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.popup.style.display === 'flex') {
        this.closePopup();
      }
    });
  }
}

function initPasswordPopup(container = document) {
  if (container.querySelector('.password-popup-content') || container.querySelector('.password-link-content')) {
    new PasswordPopup();
  }
}

document.addEventListener('DOMContentLoaded', () => initPasswordPopup());

/* Password Page Popup js end */

/* video testimonials js start */

(function () {

  class VideoGallerySection {
    constructor(container) {
      this.container = container;
      this.slideshows = container.querySelectorAll('.video-testimonials-slideshow');
      this.swipers = [];
      this.transformTimer = null;

      this.init();
    }

    init() {
      this.initSwipers();
      this.initVideoControls();
    }

    initSwipers() {
      this.slideshows.forEach(slideshow => {
        if (slideshow.swiper) {
          slideshow.swiper.destroy(true, true);
          slideshow.swiper = null;
        }

        const autoplay = slideshow.dataset.autoplay === 'true';
        const speed = parseInt(slideshow.dataset.speed) || 3000;
        const desktopSlides = parseInt(slideshow.dataset.desktopSlides) || 3;
        const mobileSlides = parseInt(slideshow.dataset.mobileSlides) || 1;

        requestAnimationFrame(() => {
          const swiperInstance = new Swiper(slideshow, {
            slidesPerView: mobileSlides,
            spaceBetween: 16,
            autoplay: autoplay ? {
              delay: speed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            } : false,

            navigation: {
              nextEl: slideshow.querySelector('.video-testimonials-slideshow-next'),
              prevEl: slideshow.querySelector('.video-testimonials-slideshow-prev'),
            },

            pagination: {
              el: slideshow.querySelector(".video-testimonials-slideshow-pagination"),
              type: "progressbar",
            },

            breakpoints: {
              0: { slidesPerView: 1 },
              450: { slidesPerView: mobileSlides },
              768: { slidesPerView: 3 },
              1024: {
                slidesPerView: desktopSlides,
                spaceBetween: 24,
              }
            },

            on: {
              init: () => {
                slideshow.classList.add('swiper-initialized');
              }
            }
          });

          slideshow.swiper = swiperInstance;
          this.swipers.push(swiperInstance);
        });
      });
    }

    initVideoControls() {
      this.container.querySelectorAll('.video-testimonials-video-play-pause-btn').forEach(btn => {
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);

        newBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const video = newBtn.closest('.video-testimonials')?.querySelector('video');
          const icon = newBtn.querySelector('.video-testimonials-video-play-pause-icon');

          if (!video || !icon) return;

          if (video.paused) {
            video.play();
            icon.innerHTML = '&#10074;&#10074;';
          } else {
            video.pause();
            icon.innerHTML = '&#9654;';
          }
        });
      });

      this.container.querySelectorAll('video').forEach(video => {
        const newVideo = video.cloneNode(true);
        video.parentNode.replaceChild(newVideo, video);

        const updateIcon = (state) => {
          const icon = newVideo.closest('.video-testimonials')
            ?.querySelector('.video-testimonials-video-play-pause-icon');

          if (!icon) return;
          icon.innerHTML = state === 'play' ? '&#10074;&#10074;' : '&#9654;';
        };

        newVideo.addEventListener('play', () => updateIcon('play'));
        newVideo.addEventListener('pause', () => updateIcon('pause'));
        newVideo.addEventListener('ended', () => updateIcon('pause'));
      });
    }

    destroy() {
      if (this.transformTimer) {
        clearTimeout(this.transformTimer);
        this.transformTimer = null;
      }

      this.slideshows.forEach(slideshow => {
        if (slideshow.swiper) {
          slideshow.swiper.destroy(true, true);
          slideshow.swiper = null;
          slideshow.classList.remove('swiper-initialized');
        }
      });

      this.swipers = [];
    }
  }

  window.videoGallerySections = window.videoGallerySections || {};

  function initSection(container) {
    const sectionId = container.dataset.sectionId || container.id;

    if (window.videoGallerySections[sectionId]) {
      window.videoGallerySections[sectionId].destroy();
    }

    window.videoGallerySections[sectionId] = new VideoGallerySection(container);
  }

  function initAll() {
    document.querySelectorAll('.video-testimonials-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.video-testimonials-section').forEach(initSection);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.video-testimonials-section').forEach(section => {
        const id = section.dataset.sectionId || section.id;
        if (window.videoGallerySections[id]) {
          window.videoGallerySections[id].destroy();
          delete window.videoGallerySections[id];
        }
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const container = event.target.closest('.video-testimonials-section');
      if (container) initSection(container);
    });
  }

})();

/* video testimonials js end */

/* before after image js start */

class BeforeAfterSection {
  constructor(section) {
    this.section = section;
    this.imgAfter = section.querySelector(".before-after-img-col-after");
    this.line = section.querySelector(".before-after-line");
    this.slider = section.querySelector(".before-after-slider");

    if (!this.imgAfter || !this.line || !this.slider) return;

    this.bindEvents();
    this.updateSlider();
  }

  updateSlider() {
    const value = this.slider.value;
    this.line.style.left = `${value}%`;
    this.imgAfter.style.clipPath = `inset(0 0 0 ${value}%)`;
  }

  resetSlider() {
    this.slider.value = 50;
    this.updateSlider();
  }

  bindEvents() {
    this.slider.addEventListener("input", () => this.updateSlider());
    this.slider.addEventListener("dblclick", () => this.resetSlider());
  }

  static initAll(container = document) {
    container.querySelectorAll(".before-after-section").forEach(section => {
      new BeforeAfterSection(section);
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  BeforeAfterSection.initAll();
});



/* before after image js end */

/* testimonials slider js start */

(function () {

  class TestimonialSlider {
    constructor(container) {
      this.container = container;
      this.sliders = container.querySelectorAll(".testimonials-slider");
      this.swipers = [];

      this.init();
    }

    init() {
      this.initSwipers();
    }

    initSwipers() {
      this.sliders.forEach(slider => {
        if (slider.swiper) {
          slider.swiper.destroy(true, true);
          slider.swiper = null;
        }

        const autoplayEnabled = slider.dataset.autoplay === "true";
        const showDots = slider.dataset.sliderDots === "true";
        const showArrows = slider.dataset.sliderArrows === "true";

        const options = {
          slidesPerView: 3,
          spaceBetween: 20,
          loop: true,
          speed: 800,

          breakpoints: {
            0: { slidesPerView: 1 },
            450: { slidesPerView: 2 },
            767: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          },
        };

        if (autoplayEnabled) {
          options.autoplay = {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }

        if (showDots) {
          options.pagination = {
            el: slider.querySelector(".testimonial-pagination"),
            type: "progressbar",
          };
        }

        if (showArrows) {
          options.navigation = {
            nextEl: slider.querySelector(".testimonial-next"),
            prevEl: slider.querySelector(".testimonial-prev"),
          };
        }

        requestAnimationFrame(() => {
          const swiperInstance = new Swiper(slider, options);
          slider.swiper = swiperInstance;
          this.swipers.push(swiperInstance);
        });
      });
    }

    destroy() {
      this.sliders.forEach(slider => {
        if (slider.swiper) {
          slider.swiper.destroy(true, true);
          slider.swiper = null;
        }
      });

      this.swipers = [];
    }

    slideToBlock(blockId) {
      const block = this.container.querySelector(`[data-block-id="${blockId}"]`);
      if (!block) return;

      const slide = block.closest('.swiper-slide');
      if (!slide) return;

      const slideIndex = slide.dataset.swiperSlideIndex;
      this.swipers.forEach(swiper => {
        if (slideIndex !== undefined) {
          swiper.slideToLoop(parseInt(slideIndex));
        }
      });
    }
  }

  window.testimonialSliders = window.testimonialSliders || {};

  function initSection(section) {
    const sectionId = section.dataset.sectionId || section.id;

    if (window.testimonialSliders[sectionId]) {
      window.testimonialSliders[sectionId].destroy();
    }

    window.testimonialSliders[sectionId] = new TestimonialSlider(section);
  }

  function initAll() {
    document.querySelectorAll(".testimonials-section").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {

    document.addEventListener("shopify:section:load", (event) => {
      event.target.querySelectorAll(".testimonials-section").forEach(initSection);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      event.target.querySelectorAll(".testimonials-section").forEach(section => {
        const id = section.dataset.sectionId || section.id;
        if (window.testimonialSliders[id]) {
          window.testimonialSliders[id].destroy();
          delete window.testimonialSliders[id];
        }
      });
    });

    document.addEventListener("shopify:block:select", (event) => {
      const section = event.target.closest(".testimonials-section");
      if (section) {
        const id = section.dataset.sectionId || section.id;
        const instance = window.testimonialSliders[id];
        const blockId = event.detail.blockId;
        if (instance && blockId) {
          instance.slideToBlock(blockId);
        } else {
          initSection(section);
        }
      }
    });
  }

})();

/* testimonials slider js end */

/* textarea js start */

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('mousedown', (e) => {
    if (e.target.tagName === 'TEXTAREA') {
      const textarea = e.target;

      setTimeout(() => {
        if (document.activeElement === textarea) {
          textarea.setSelectionRange(0, 0);
        }
      }, 0);
    }
  });

  document.addEventListener('focus', (e) => {
    if (e.target.tagName === 'TEXTAREA') {
      setTimeout(() => {
        e.target.setSelectionRange(0, 0);
      }, 0);
    }
  }, true);
});

/* textarea js end */

/* Image card js start */

(function () {

  class ImageCardSection {
    constructor(container) {
      this.container = container;
      this.slideshows = container.querySelectorAll('.image-card-slideshow');
      this.swipers = [];
      this.transformTimer = null;
      this.init();
    }

    init() {
      this.initSwipers();
    }

    initSwipers() {
      this.slideshows.forEach(slideshow => {

        if (slideshow.swiper) {
          slideshow.swiper.destroy(true, true);
          slideshow.swiper = null;
        }

        const autoplay = slideshow.dataset.autoplay === 'true';
        const speed = parseInt(slideshow.dataset.speed) || 3000;
        const desktopSlides = parseInt(slideshow.dataset.desktopSlides) || 3;
        const mobileSlides = parseInt(slideshow.dataset.mobileSlides) || 1;

        requestAnimationFrame(() => {
          const swiperInstance = new Swiper(slideshow, {
            slidesPerView: mobileSlides,
            spaceBetween: 10,
            loop: true,

            autoplay: autoplay ? {
              delay: speed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            } : false,

            navigation: {
              nextEl: slideshow.querySelector('.image-card-slideshow-next'),
              prevEl: slideshow.querySelector('.image-card-slideshow-prev'),
            },

            pagination: {
              el: slideshow.querySelector(".image-card-slideshow-pagination-progressbar"),
              type: "progressbar",
            },

            breakpoints: {
              0: { slidesPerView: 1 },
              450: { slidesPerView: mobileSlides },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: desktopSlides }
            },

            on: {
              init: () => slideshow.classList.add('swiper-initialized')
            }
          });

          slideshow.swiper = swiperInstance;
          this.swipers.push(swiperInstance);
        });
      });
    }

    destroy() {
      if (this.transformTimer) {
        clearTimeout(this.transformTimer);
        this.transformTimer = null;
      }

      this.slideshows.forEach(slideshow => {
        if (slideshow.swiper) {
          slideshow.swiper.destroy(true, true);
          slideshow.swiper = null;
          slideshow.classList.remove('swiper-initialized');
        }
      });

      this.swipers = [];
    }

    slideToBlock(blockId) {
      const block = this.container.querySelector(`[data-block-id="${blockId}"]`);
      if (!block) return;

      const slide = block.closest('.swiper-slide');
      if (!slide) return;

      const slideIndex = slide.dataset.swiperSlideIndex;
      this.swipers.forEach(swiper => {
        if (slideIndex !== undefined) {
          swiper.slideToLoop(parseInt(slideIndex));
        }
      });
    }
  }

  window.imageCardSections = window.imageCardSections || {};

  function initSection(section) {
    const sectionId = section.dataset.sectionId || section.id;

    if (window.imageCardSections[sectionId]) {
      window.imageCardSections[sectionId].destroy();
    }

    window.imageCardSections[sectionId] = new ImageCardSection(section);
  }

  function initAll() {
    document.querySelectorAll('.image-card-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.image-card-section').forEach(initSection);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.image-card-section').forEach(section => {
        const id = section.dataset.sectionId || section.id;
        if (window.imageCardSections[id]) {
          window.imageCardSections[id].destroy();
          delete window.imageCardSections[id];
        }
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest('.image-card-section');
      if (section) {
        const id = section.dataset.sectionId || section.id;
        const instance = window.imageCardSections[id];
        const blockId = event.detail.blockId;
        if (instance && blockId) {
          instance.slideToBlock(blockId);
        } else {
          initSection(section);
        }
      }
    });
  }

})();

/* Image card js end */

/* Country selector js start */


class CountryDropdown {
  constructor(dropdown) {
    this.dropdown = dropdown;
    this.button = dropdown.querySelector('.country-dropdown');
    this.list = dropdown.querySelector('.country-list');
    this.input = dropdown.querySelector('input[name="country_code"]');

    if (this.button && this.list && this.input) {
      this.button.addEventListener('click', this.toggleDropdown.bind(this));
      this.list.addEventListener('click', this.onItemClick.bind(this));
      this.button.addEventListener('keydown', this.onContainerKeyUp.bind(this));
      this.list.addEventListener('keydown', this.onContainerKeyUp.bind(this));
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }
  }

  toggleDropdown() {
    const expanded = this.button.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      this.button.setAttribute('aria-expanded', 'false');
      this.list.setAttribute('hidden', '');
    } else {
      this.closeOtherDropdowns();
      this.button.setAttribute('aria-expanded', 'true');
      this.list.removeAttribute('hidden');
    }
  }

  closeOtherDropdowns() {
    const allDropdowns = document.querySelectorAll('.dropdown');
    allDropdowns.forEach(otherDropdown => {
      if (otherDropdown !== this.dropdown) {
        const otherList = otherDropdown.querySelector('.country-list');
        const otherButton = otherDropdown.querySelector('.country-dropdown');
        if (otherList && otherButton) {
          otherList.setAttribute('hidden', '');
          otherButton.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  onItemClick(event) {
    const countryItem = event.target.closest('.country-item');
    if (countryItem) {
      const selectedValue = countryItem.dataset.value;
      this.input.value = selectedValue;
      const countryText = countryItem.innerHTML;
      this.updateAllDropdowns(countryText, selectedValue);
      this.closeDropdown();

      const form = this.dropdown.closest('form');
      if (form) {
        form.submit();
      }
    }
  }

  onContainerKeyUp(event) {
    const key = (event.code || event.key || '').toUpperCase();
    if (key === 'ESCAPE' || key === 'ESC') {
      this.closeDropdown();
    }
  }

  onDocumentClick(event) {
    if (!this.dropdown.contains(event.target)) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    this.list.setAttribute('hidden', '');
    this.button.setAttribute('aria-expanded', 'false');
  }

  updateAllDropdowns(countryText, selectedValue) {
    const allDropdowns = document.querySelectorAll('.dropdown');
    allDropdowns.forEach(dropdown => {
      const button = dropdown.querySelector('.country-dropdown');
      const input = dropdown.querySelector('input[name="country_code"]');
      const selectedCountrySpan = dropdown.querySelector('.selected-country');

      if (button && input && selectedCountrySpan) {
        selectedCountrySpan.innerHTML = countryText;
        input.value = selectedValue;
      }
    });
  }
}

function initCountryDropdowns(container = document) {
  const dropdowns = container.querySelectorAll('.dropdown');
  dropdowns.forEach(dropdown => {
    if (dropdown) {
      new CountryDropdown(dropdown);
    }
  });
}

window.addEventListener('DOMContentLoaded', () => initCountryDropdowns());

/* Country selector js end */

/* Language selector js start */

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: null,
      button: null,
      panel: null
    };
  }

  connectedCallback() {
    this.elements.input = this.querySelector('input[name="language_code"]');
    this.elements.button = this.querySelector('.language_form_button');
    this.elements.panel = this.querySelector('.disclosure__list');

    if (this.elements.button && this.elements.panel && this.elements.input) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
  }

  hidePanel() {
    if (this.elements.button && this.elements.panel) {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      this.hidePanel();
      if (this.elements.button) this.elements.button.focus();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (this.elements.input) {
      this.elements.input.value = event.currentTarget.dataset.value;
    }
    if (form) form.submit();
  }

  openSelector() {
    if (this.elements.button && this.elements.panel) {
      this.elements.button.focus();
      const isHidden = this.elements.panel.hasAttribute('hidden');

      if (isHidden) {
        this.elements.panel.removeAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', 'true');
      } else {
        this.elements.panel.setAttribute('hidden', '');
        this.elements.button.setAttribute('aria-expanded', 'false');
      }
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  customElements.define('localization-form', LocalizationForm);
});

/* Language selector js end */

/* multi-column js start */

(function () {

  class MultiColumnSection {
    constructor(container) {
      this.container = container;
      this.slideshows = container.querySelectorAll('.multicolumn-slideshow');
      this.swipers = [];
      this.resizeTimer = null;

      this.init();
      this.bindEvents();
    }

    init() {
      this.initSwipers();
    }

    initSwipers() {
      this.slideshows.forEach(slideshow => {

        if (slideshow.swiper) {
          slideshow.swiper.destroy(true, true);
          slideshow.swiper = null;
        }

        const desktopView = slideshow.dataset.desktopView || 'grid';
        const mobileSlideshow = slideshow.dataset.mobileSlideshow === 'true';
        const desktopSlides = parseInt(slideshow.dataset.desktopSlides) || 3;
        const mobileSlides = parseInt(slideshow.dataset.mobileSlides) || 1;
        const autoplay = slideshow.dataset.autoplay === 'true';
        const speed = parseInt(slideshow.dataset.speed) || 3000;
        const enableLoop = slideshow.dataset.enableLoop === 'true';

        const isMobile = window.innerWidth < 768;
        const shouldEnableSlider = (isMobile && mobileSlideshow) || (!isMobile && desktopView === 'slideshow');

        if (!shouldEnableSlider) return;

        requestAnimationFrame(() => {
          const swiperInstance = new Swiper(slideshow, {
            slidesPerView: mobileSlides,
            spaceBetween: 15,
            loop: enableLoop,

            autoplay: autoplay ? {
              delay: speed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            } : false,

            navigation: {
              nextEl: slideshow.querySelector('.multicolumn-slideshow-next'),
              prevEl: slideshow.querySelector('.multicolumn-slideshow-prev'),
            },

            pagination: {
              el: slideshow.querySelector('.multicolumn-slideshow-pagination'),
              type: "progressbar",
            },

            breakpoints: {
              0: { slidesPerView: 1, spaceBetween: 15 },
              450: { slidesPerView: mobileSlides, spaceBetween: 15 },
              768: { slidesPerView: 3, spaceBetween: 20 },
              1024: { slidesPerView: desktopSlides, spaceBetween: 24 },
            },

            on: {
              init: () => slideshow.classList.add('swiper-initialized')
            }
          });

          slideshow.swiper = swiperInstance;
          this.swipers.push(swiperInstance);
        });
      });
    }

    bindEvents() {
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.initSwipers();
        }, 250);
      });
    }

    destroy() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }

      this.slideshows.forEach(slideshow => {
        if (slideshow.swiper) {
          slideshow.swiper.destroy(true, true);
          slideshow.swiper = null;
          slideshow.classList.remove('swiper-initialized');
        }
      });

      this.swipers = [];
    }

    slideToBlock(blockId) {
      const block = this.container.querySelector(`[data-block-id="${blockId}"]`);
      if (!block) return;

      const slide = block.closest('.swiper-slide');
      if (!slide) return;

      const slideIndex = slide.dataset.swiperSlideIndex;
      this.swipers.forEach(swiper => {
        if (slideIndex !== undefined) {
          swiper.slideToLoop(parseInt(slideIndex));
        }
      });
    }
  }

  window.MultiColumns = window.MultiColumns || {};

  function initSection(section) {
    const sectionId = section.dataset.sectionId || section.id;

    if (window.MultiColumns[sectionId]) {
      window.MultiColumns[sectionId].destroy();
    }

    window.MultiColumns[sectionId] = new MultiColumnSection(section);
  }

  function initAll() {
    document.querySelectorAll('.multicolumn-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.multicolumn-section').forEach(initSection);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.multicolumn-section').forEach(section => {
        const id = section.dataset.sectionId || section.id;
        if (window.MultiColumns[id]) {
          window.MultiColumns[id].destroy();
          delete window.MultiColumns[id];
        }
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest('.multicolumn-section');
      if (section) {
        const id = section.dataset.sectionId || section.id;
        const instance = window.MultiColumns[id];
        const blockId = event.detail.blockId;
        if (instance && blockId) {
          instance.slideToBlock(blockId);
        } else {
          initSection(section);
        }
      }
    });
  }

})();

/* multi-column js end */

/* gallery slideshow js start */

(function () {

  class GallerySection {
    constructor(container) {
      this.container = container;
      this.slideshows = container.querySelectorAll('.gallery-slideshow');
      this.swipers = [];
      this.transformTimer = null;

      this.init();
    }

    init() {
      this.initSwipers();
    }

    initSwipers() {
      this.slideshows.forEach(slideshow => {
        if (slideshow.swiper) {
          slideshow.swiper.destroy(true, true);
          slideshow.swiper = null;
        }

        const autoplay = slideshow.dataset.autoplay === 'true';
        const speed = parseInt(slideshow.dataset.speed) || 3000;
        const desktopSlides = parseInt(slideshow.dataset.desktopSlides) || 3;
        const mobileSlides = parseInt(slideshow.dataset.mobileSlides) || 1;

        requestAnimationFrame(() => {
          const swiperInstance = new Swiper(slideshow, {
            slidesPerView: mobileSlides,
            spaceBetween: 16,
            autoplay: autoplay ? {
              delay: speed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            } : false,

            navigation: {
              nextEl: slideshow.querySelector('.gallery-slideshow-next'),
              prevEl: slideshow.querySelector('.gallery-slideshow-prev'),
            },

            pagination: {
              el: slideshow.querySelector(".gallery-slideshow-pagination-progressbar"),
              type: "progressbar",
            },

            breakpoints: {
              0: { slidesPerView: 1 },
              450: { slidesPerView: mobileSlides },
              768: { slidesPerView: 3 },
              1024: {
                slidesPerView: desktopSlides,
                spaceBetween: 24,
              }
            },

            on: {
              init: () => slideshow.classList.add('swiper-initialized')
            }
          });

          slideshow.swiper = swiperInstance;
          this.swipers.push(swiperInstance);
        });
      });
    }

    destroy() {
      if (this.transformTimer) {
        clearTimeout(this.transformTimer);
        this.transformTimer = null;
      }

      this.slideshows.forEach(slideshow => {
        if (slideshow.swiper) {
          slideshow.swiper.destroy(true, true);
          slideshow.swiper = null;
          slideshow.classList.remove('swiper-initialized');
        }
      });

      this.swipers = [];
    }

    slideToBlock(blockId) {
      const block = this.container.querySelector(`[data-block-id="${blockId}"]`);
      if (!block) return;

      const slide = block.closest('.swiper-slide');
      if (!slide) return;

      const slideIndex = slide.dataset.swiperSlideIndex;
      this.swipers.forEach(swiper => {
        if (slideIndex !== undefined) {
          swiper.slideToLoop(parseInt(slideIndex));
        }
      });
    }
  }

  window.gallerySections = window.gallerySections || {};

  function initSection(section) {
    const sectionId = section.dataset.sectionId || section.id;

    if (window.gallerySections[sectionId]) {
      window.gallerySections[sectionId].destroy();
    }

    window.gallerySections[sectionId] = new GallerySection(section);
  }

  function initAll() {
    document.querySelectorAll('.gallery-slideshow-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.gallery-slideshow-section').forEach(initSection);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.gallery-slideshow-section').forEach(section => {
        const id = section.dataset.sectionId || section.id;
        if (window.gallerySections[id]) {
          window.gallerySections[id].destroy();
          delete window.gallerySections[id];
        }
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest('.gallery-slideshow-section');
      if (section) {
        const id = section.dataset.sectionId || section.id;
        const instance = window.gallerySections[id];
        const blockId = event.detail.blockId;
        if (instance && blockId) {
          instance.slideToBlock(blockId);
        } else {
          initSection(section);
        }
      }
    });
  }

})();

/* gallery slideshow js end */

/* rich text js start */

(function () {
  function initScrollAnimations() {
    const scrollElements = document.querySelectorAll('.scroll-fade-in');
    const imageElements = document.querySelectorAll('.scroll-image-reveal');

    const elementInView = (el, offset = 150) => {
      const elementTop = el.getBoundingClientRect().top;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      return elementTop <= windowHeight - offset;
    };

    const displayScrollElement = (element) => {
      if (element.classList.contains('is-visible')) return;

      const delay = parseInt(element.getAttribute('data-scroll-delay')) || 0;

      setTimeout(() => {
        element.classList.add('is-visible');
      }, delay);
    };

    const handleScrollAnimation = () => {
      scrollElements.forEach((el) => {
        if (elementInView(el, 150)) {
          displayScrollElement(el);
        }
      });

      imageElements.forEach((el) => {
        if (elementInView(el, 100)) {
          displayScrollElement(el);
        }
      });
    };

    setTimeout(handleScrollAnimation, 100);
    setTimeout(handleScrollAnimation, 500);

    let throttleTimer = false;
    const throttleDelay = 100;

    window.addEventListener('scroll', () => {
      if (throttleTimer) return;

      throttleTimer = true;
      setTimeout(() => {
        handleScrollAnimation();
        throttleTimer = false;
      }, throttleDelay);
    }, { passive: true });

    window.addEventListener('resize', handleScrollAnimation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initScrollAnimations);
    document.addEventListener('shopify:section:reorder', initScrollAnimations);
  }
})();

/* rich text js end */

/* shop the look js start */

function initShopTheLook(container = document) {
  const hotspotWrappers = container.querySelectorAll('.shop-the-look-hotspot-wrapper');
  let hoverTimeout;

  hotspotWrappers.forEach(wrapper => {
    const hotspot = wrapper.querySelector('.shop-the-look-hotspot');
    if (!hotspot) return;

    let lastEnterTime = 0;

    hotspot.addEventListener('click', function (e) {
      e.stopPropagation();
      const now = Date.now();

      hotspotWrappers.forEach(w => {
        if (w !== wrapper) {
          w.classList.remove('active');
        }
      });

      if (now - lastEnterTime < 300) {
        wrapper.classList.add('active');
      } else {
        wrapper.classList.toggle('active');
      }
    });

    wrapper.addEventListener('mouseenter', function () {
      lastEnterTime = Date.now();
      clearTimeout(hoverTimeout);

      hotspotWrappers.forEach(w => {
        if (w !== wrapper) {
          w.classList.remove('active');
        }
      });

      wrapper.classList.add('active');
    });

    wrapper.addEventListener('mouseleave', function () {
      hoverTimeout = setTimeout(() => {
        wrapper.classList.remove('active');
      }, 200);
    });

    const popup = wrapper.querySelector('.shop-the-look-popup');
    if (popup) {
      popup.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimeout);
      });

      popup.addEventListener('mouseleave', function () {
        hoverTimeout = setTimeout(() => {
          wrapper.classList.remove('active');
        }, 200);
      });

      popup.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  });

  document.addEventListener('click', function () {
    hotspotWrappers.forEach(w => w.classList.remove('active'));
  });
}

document.addEventListener('DOMContentLoaded', () => initShopTheLook());

/* shop the look js end */

/* collection list js start */

(function () {

  class CollectionListSlider {
    constructor(container) {
      this.container = container;
      this.swiperInstance = null;
      this.init();
    }

    init() {
      this.initSwiper();
    }

    initSwiper() {
      const swiperElement = this.container.querySelector(".collection-list-slideshow");
      if (!swiperElement) return;

      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }

      const autoplay = swiperElement.dataset.autoplay === "true";
      const speed = parseInt(swiperElement.dataset.speed) || 3000;
      const desktopSlides = parseInt(swiperElement.dataset.desktopSlides) || 3;
      const mobileSlides = parseInt(swiperElement.dataset.mobileSlides) || 1;

      requestAnimationFrame(() => {
        this.swiperInstance = new Swiper(swiperElement, {
          slidesPerView: mobileSlides,
          spaceBetween: 16,
          autoplay: autoplay
            ? {
              delay: speed,
              disableOnInteraction: false,
            }
            : false,

          navigation: {
            nextEl: swiperElement.querySelector(".collection-list-slideshow-next"),
            prevEl: swiperElement.querySelector(".collection-list-slideshow-prev"),
          },

          pagination: {
            el: ".collection-list-slideshow-pagination-progressbar",
            type: "progressbar",
          },

          breakpoints: {
            0: { 
              slidesPerView: mobileSlides,
              spaceBetween: 12
            },
            450: { 
              slidesPerView: mobileSlides,
              spaceBetween: 16
            },
            768: { 
              slidesPerView: 3,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: desktopSlides,
              spaceBetween: 24,
            },
          },
        });
      });
    }

    destroy() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  window.CollectionListSliders = window.CollectionListSliders || {};

  function initCollectionSlider(container) {
    const sectionId = container.dataset.sectionId;

    if (window.CollectionListSliders[sectionId]) {
      window.CollectionListSliders[sectionId].destroy();
    }

    window.CollectionListSliders[sectionId] = new CollectionListSlider(container);
  }

  function initAllCollectionSliders() {
    document.querySelectorAll(".collection-list-section").forEach(initCollectionSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllCollectionSliders);
  } else {
    initAllCollectionSliders();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", initAllCollectionSliders);

    document.addEventListener("shopify:section:unload", function (event) {
      const container = event.target.querySelector(".collection-list-section");
      if (!container) return;

      const sectionId = container.dataset.sectionId;
      if (window.CollectionListSliders[sectionId]) {
        window.CollectionListSliders[sectionId].destroy();
        delete window.CollectionListSliders[sectionId];
      }
    });

    document.addEventListener("shopify:block:select", initAllCollectionSliders);
  }

})();

/* collection list js end */

/* visual story js start */

function initVisualStory(container = document) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  container.querySelectorAll('.reveal-node').forEach(el => observer.observe(el));
}

document.addEventListener("DOMContentLoaded", () => initVisualStory());

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target.querySelector('.before-after-section')) BeforeAfterSection.initAll(target);
    if (target.querySelector('.faq-section')) initFAQSections(target);
    if (target.querySelector('.shop-the-look-section')) initShopTheLook(target);
    if (target.querySelector('.visual-story-section')) initVisualStory(target);
    if (target.querySelector('.password-input-wrapper')) {
      if (typeof reinitPasswordToggles === 'function') reinitPasswordToggles();
    }
    if (target.querySelector('.dropdown')) initCountryDropdowns(target);
    if (target.querySelector('.login-page-login') || target.querySelector('.login-page-recovery')) initLoginPage(target);
    if (target.querySelector('.password-popup-content')) initPasswordPopup(target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;

    if (block.classList.contains('faq-item')) {
      const section = block.closest('.faq-section');
      if (section) {
        const FAQItems = section.querySelectorAll('.faq-item');
        const allowMultiple = section.getAttribute('data-allow-multiple') === 'true';
        if (!block.classList.contains('active')) {
          toggleFAQ(block, FAQItems, allowMultiple);
        }
      }
    }

    if (block.classList.contains('shop-the-look-hotspot-wrapper')) {
      const section = block.closest('.shop-the-look-section');
      if (section) {
        section.querySelectorAll('.shop-the-look-hotspot-wrapper').forEach(w => w.classList.remove('active'));
        block.classList.add('active');
        block.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    if (block.classList.contains('visual-story-tile')) {
      block.classList.add('visible');
      block.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const block = event.target;

    if (block.classList.contains('faq-item')) {
      if (block.classList.contains('active')) {
        const toggle = block.querySelector('[data-FAQ-toggle]');
        block.classList.remove('active');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    }

    if (block.classList.contains('shop-the-look-hotspot-wrapper')) {
      block.classList.remove('active');
    }
  });
}

/* visual story js end */

/* media grid js start */

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.scroll-down');
  if (!btn) return;

  e.preventDefault();
  const currentShopifySection = btn.closest('.shopify-section');
  if (!currentShopifySection) return;

  let nextShopifySection = currentShopifySection.nextElementSibling;
  while (
    nextShopifySection &&
    !nextShopifySection.classList.contains('shopify-section')
  ) {
    nextShopifySection = nextShopifySection.nextElementSibling;
  }

  if (!nextShopifySection) return;

  const header = document.querySelector('[data-sticky-header]');
  const headerOffset = header ? header.offsetHeight : 0;
  const nextSectionTop = nextShopifySection.getBoundingClientRect().top;

  const targetPosition =
    nextSectionTop +
    window.pageYOffset -
    headerOffset;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
});

/* media grid js end */

/* video play pause js start */
document.addEventListener('play', function (e) {
  if (e.target.tagName === 'VIDEO') {
    document.querySelectorAll('video').forEach(function (v) {
      if (v !== e.target && !v.paused) v.pause();
    });
  }
}, true);

document.addEventListener('click', function (e) {
  var nativeVideo = e.target.closest('video');
  if (nativeVideo && !nativeVideo.hasAttribute('controls')) {
    if (nativeVideo.paused) nativeVideo.play();
    else nativeVideo.pause();
  }
});

/* video play pause js end */